import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../web/src/components/interactive/button.jsx';
import { usePageTitle } from '../layout/use-page-title.js';
import { useInView } from '../layout/use-in-view.js';
import { APP_URL } from '../app-config.js';
import { HomeHero } from '../components/home-hero.jsx';
import { UseCaseIcon } from '../components/use-case-icon.jsx';
import { UseCaseGrid } from '../components/use-case-grid.jsx';

/**
 * Home page: hero, growing section, the use-case grid, and a CTA band.
 * @returns {JSX.Element}
 */
export function HomePage() {
	const { lang } = useParams();
	const { t } = useTranslation();
	const { ref, inView } = useInView();
	usePageTitle('site.home.title', 'site.meta.home.description');

	return (
		<>
			<HomeHero />
			<section ref={ref} className={`section growing reveal${inView ? ' is-visible' : ''}`}>
				<UseCaseIcon kind="leaf" className="growing-icon" />
				<h2 className="growing-title">{t('site.home.growing.title')}</h2>
				<p className="growing-body">{t('site.home.growing.body')}</p>
			</section>
			<section className="section use-cases">
				<h2>{t('site.home.useCases.title')}</h2>
				<p className="section-lede">{t('site.home.useCases.lede')}</p>
				<UseCaseGrid featured />
				<div className="use-cases-more">
					<Button as="link" to={`/${lang}/use-cases/`} variant="ghost">{t('site.home.useCases.seeMore')}</Button>
				</div>
			</section>
			<section className="section cta-band">
				<h2>{t('site.footer.tagline')}</h2>
				<Button as="a" href={APP_URL} target="_blank" variant="primary">{t('site.home.ctaPrimary')}</Button>
			</section>
		</>
	);
}
